import { Stations as BaseStations } from '@sagano/share/stores';

export class Stations extends BaseStations {}

export default new Stations();
